<template>
    <div class="modal fade custom-scrollbar"
         :style="'cursor: url('+cursorImage()+'), auto !important'"
         :class="[modalSize === 'fullscreen' ? 'border-0 p-0 m-0' : '']"
         :data-backdrop="modalBackdrop ? modalBackdrop : 'static'"
         :data-keyboard="`${modalBackdrop}`"
         :id="modalId"
         tabindex="-1"
         role="dialog"
         aria-hidden="true">
        <div class="modal-dialog"
             :class="[modalAlignment === 'top' ? 'modal-dialog-top' : 'modal-dialog-centered', checkModalSize,{'modal-dialog-scrollable':modalScroll}]"
             role="document">
            <div class="modal-content">
                <div v-if="$slots.header" :key="modalId+'header'" class="modal-header">
                    <slot name="header"></slot>
                </div>

                <div v-if="$slots.body" :key="modalId+'body'" class="modal-body custom-scrollbar" :class="modalBodyClass">
                    <slot name="body"></slot>
                </div>

                <div v-if="$slots.footer" :key="modalId+'footer'" class="modal-footer">
                    <slot name="footer"></slot>
                </div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import AppFunction from "../../helpers/app/AppFunction";
import OverlayStack from "../../helpers/app/OverlayStack";

export default {
    name: "AppModal",
    props: {
        modalId: {
            type: String,
            required: true
        },
        modalSize: {
            type: String,
            default: 'default'
        },
        modalAlignment: {
            type: String,
            default: 'top'
        },
        modalScroll: {
            type: Boolean,
            default: true
        },
        modalBodyClass: {
            type: String
        },
        modalBackdrop: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            overlayZIndex: 1050,
        }
    },
    mounted() {
        if (this.$el.parentNode !== document.body) {
            document.body.appendChild(this.$el);
        }

        this.$modal = $('#' + this.modalId);
        this.eventNamespace = `.app-modal-${this.modalId}`;

        this.$modal.on(`show.bs.modal${this.eventNamespace}`, () => {
            this.overlayZIndex = OverlayStack.nextZIndex(this.modalId);
            this.$modal.css('z-index', this.overlayZIndex);
        });

        this.$modal.on(`shown.bs.modal${this.eventNamespace}`, () => {
            this.applyBackdropZIndex();
            OverlayStack.syncBodyState();
        });

        this.$modal.on(`hidden.bs.modal${this.eventNamespace}`, () => {
            OverlayStack.syncBodyState();
            this.$emit('close-modal', false);
        });

        this.$modal.modal('show');
    },
    beforeDestroy() {
        if (this.$modal) {
            this.$modal.off(this.eventNamespace);
        }

        OverlayStack.syncBodyState();
    },
    computed: {
        checkModalSize() {
            if (this.modalSize === 'default') return "modal-default";
            else if (this.modalSize === 'small') return "modal-sm";
            else if (this.modalSize === 'large') return "modal-lg";
            else if (this.modalSize === 'extra-large') return "modal-xl";
            else if (this.modalSize === 'full-width') return "modal-fullwidth";
            else if (this.modalSize === 'fullscreen') return "full-screen-modal-dialog";
            else return '';
        }
    },
    methods: {
        applyBackdropZIndex() {
            const backdrops = Array.from(document.querySelectorAll('.modal-backdrop'));
            const backdrop = backdrops[backdrops.length - 1];

            if (!backdrop) {
                return;
            }

            backdrop.style.zIndex = `${this.overlayZIndex - 10}`;
            backdrop.dataset.overlayOwner = this.modalId;
        },
        cursorImage(){
            if (this.$store.state.theme.darkMode) {
                return AppFunction.getAppUrl('images/close-cursor-dark.png');
            } else {
                return AppFunction.getAppUrl('images/close-cursor-light.png');
            }
        }
    }
}
</script>
